import BaseBusinessAPI from '../portal/baseBusinessAPI'

class LocationAPI extends BaseBusinessAPI {
  controllerName = 'Locations';
}

export default new LocationAPI()
